<h1 mat-dialog-title>SMS notificatie</h1>

<mat-dialog-content>
  <form [formGroup]="form" class="flex flex-col gap-4">
    <div class="space-y-2">
      <label for="sms-message" class="block font-medium text-sm select-none"
        >Bericht</label
      >
      <mat-form-field class="w-full">
        <textarea
          id="sms-message"
          matInput
          rows="4"
          formControlName="message"
        ></textarea>

        <mat-hint align="end"
          >{{ controls.message.value?.length }}/160 karakters</mat-hint
        >

        @if (controls.message.hasError('required')) {
          <mat-error>Vul een bericht in</mat-error>
        } @else if (controls.message.hasError('maxlength')) {
          <mat-error
            >Max.
            {{ controls.message.getError('maxlength').requiredLength }}
            karakters</mat-error
          >
        }
      </mat-form-field>
    </div>

    @if (canReadContacts()) {
      <div class="space-y-2">
        <div class="flex items-center gap-2">
          <span class="font-medium text-sm flex-1">Ontvangers</span>

          @if (canCreateContacts()) {
            <button
              type="button"
              class="text-xs text-blue-600 hover:underline cursor-pointer"
              [disabled]="submitted()"
              (click)="handleAddContact()"
            >
              Contact toevoegen
            </button>
          }

          @if (searching()) {
            <mat-progress-spinner diameter="16" mode="indeterminate" />
          }
        </div>

        <mat-form-field class="w-full">
          <mat-chip-grid #chipGrid [disabled]="submitted()">
            @for (recipient of recipientsArray.controls; track $index) {
              <mat-chip-row (removed)="handleRecipientRemove($index)">
                {{ recipient.value.name }}

                <button matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }

            <input
              placeholder="Zoek of kies ontvanger"
              #recipientInput
              [formControl]="currentRecipient"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipGrid"
              (input)="onSearchInput(recipientInput.value)"
            />
          </mat-chip-grid>

          <mat-autocomplete
            #auto="matAutocomplete"
            [displayWith]="displayRecipientValue"
            (opened)="onPanelOpened()"
            (optionSelected)="handleRecipientSelected($event); recipientInput.value = ''"
          >
            @for (recipient of recipientList(); track $index) {
              <mat-option
                [value]="recipient"
                [disabled]="isRecipientAlreadySelected(recipient)"
                >{{ recipient.name }}</mat-option
              >
            }
          </mat-autocomplete>

          @if (recipientsArray.hasError('atLeast')) {
            <mat-error
              >Kies minimaal
              {{ recipientsArray.getError('atLeast').requiredLength }}
              ontvanger</mat-error
            >
          }
        </mat-form-field>
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close [disabled]="submitted()">Annuleren</button>

  <button mat-button (click)="handleConfirm()" [disabled]="submitted() || form.invalid">
    <mat-spinner
      class="!absolute inset-0 m-auto pointer-events-none transition-opacity ease-in-out"
      [diameter]="16"
      [class.opacity-100]="loading()"
      [class.opacity-0]="!loading()"
    ></mat-spinner>

    <span [class.opacity-0]="loading()" class="transition-opacity">Opslaan</span>
  </button>
</mat-dialog-actions>
